module.exports = __webpack_public_path__ + "static/media/close.20bc43e4.svg";